/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ network: NonNullable<unknown> }} Eventaistartscreenshothint4Inputs */

const en_eventaistartscreenshothint4 = /** @type {(inputs: Eventaistartscreenshothint4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.network} won't let us read the post right now. Take a screenshot of the post and paste it here (Ctrl+V), and Pulsify fills in everything.`)
};

const de_eventaistartscreenshothint4 = /** @type {(inputs: Eventaistartscreenshothint4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.network} lässt uns den Beitrag gerade nicht lesen. Mach einen Screenshot vom Beitrag und füg ihn hier ein (Strg+V), dann füllt Pulsify alles aus.`)
};

/**
* | output |
* | --- |
* | "{network} won't let us read the post right now. Take a screenshot of the post and paste it here (Ctrl+V), and Pulsify fills in everything." |
*
* @param {Eventaistartscreenshothint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartscreenshothint4 = /** @type {((inputs: Eventaistartscreenshothint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartscreenshothint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartscreenshothint4(inputs)
	return de_eventaistartscreenshothint4(inputs)
});
export { eventaistartscreenshothint4 as "eventAiStartScreenshotHint" }